import {
  xlsxToWorkbook,
  workbookToworksheetByIndex,
  workSheetToColumnHeaders,
  columnIndexToColumnLetter,
  worksheetToRowCount,
} from "components/Shared/Formatters/XLSX";
import {
  numberToLabel
} from "components/Shared/Formatters";

export default ({
  sheets: async ({
    value: expectedSheets,
    parsedAcceptedFile
  }) => {
    const workbook = await xlsxToWorkbook(parsedAcceptedFile.file);
    const errors = [];

    //Checking if the file has enough Sheets
    if(workbook.SheetNames.length !== expectedSheets.length) {
      errors.push(`${parsedAcceptedFile.name} has ${numberToLabel({ count: workbook.SheetNames.length, label: "sheet"})}, it must have ${numberToLabel({count: expectedSheets.length, label: "sheet"})}.`);
    }

    //Mapping through the specifics of each Expected Sheet
    expectedSheets.map(({
      name: expectedSheetName,
      columns: expectedSheetColumnNames,
    }, sheetIndex) => { 

      //Checking if Sheet is named correctly
      if(expectedSheetName && expectedSheetName !== workbook.SheetNames[sheetIndex])
        errors.push(`Sheet ${sheetIndex + 1} is named ${workbook.SheetNames[sheetIndex]}, it must be named ${expectedSheetName}.`);

      const worksheet = workbookToworksheetByIndex({workbook, index: sheetIndex});
      const sheetname = name || workbook.SheetNames[sheetIndex];

      if(worksheetToRowCount(worksheet) === 0)
        errors.push(`${sheetname} contains no data.`);

      //If the Sheet is named correctly we'll check the Sheet's Columns
      if(expectedSheetColumnNames) {
        const columnHeaders = workSheetToColumnHeaders(worksheet);

        //Checking Column Count
        if(expectedSheetColumnNames.length !== columnHeaders.length) {
          //If the Sheet has no columns then we'll simply say its empty
          if(columnHeaders.length === 0) {
            errors.push(`${sheetname} is empty.`);
          //If the Sheet has columns we'll be more specific
          } else {
            errors.push(`${sheetname} has ${numberToLabel({count: columnHeaders.length, label: "column"})}, it must have ${numberToLabel({count: expectedSheetColumnNames.length, label: "column"})}. Please ensure that you are using the latest template.`);
          }
        }

        //Checking if each column is named correctly
        expectedSheetColumnNames.map((expectedSheetColumnName, columnIndex) => 
          //If the Column has no name
          Object.is(columnHeaders[columnIndex], "") ? (
            errors.push(`Column ${columnIndexToColumnLetter(columnIndex)} is not named, it must be named ${expectedSheetColumnName}.`)
          ) : (
          //If the Column has the wrong name
            (columnHeaders[columnIndex] && columnHeaders[columnIndex] !== expectedSheetColumnName) &&
              errors.push(`Column ${columnIndexToColumnLetter(columnIndex)} is named ${columnHeaders[columnIndex]}, it must be named ${expectedSheetColumnName}.`)
          )
        );
      }
    });
    return errors;
  },
});


